var _style, _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJournal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "journal_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".journal_svg__st0{fill:var(--color-icon-primary)}.journal_svg__st1,.journal_svg__st2{fill:none;stroke:var(--color-text);stroke-width:3;stroke-miterlimit:10}.journal_svg__st2{stroke-linecap:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "journal_svg__st0",
    d: "M97 23.3h15v15zM36 131v-15.1L51 131z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "journal_svg__st1",
    d: "M88.4 18h28.9v119H30.7V18h28.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "journal_svg__st2",
    d: "M74 55.1h21M74 77.5h21M74 99.9h21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "journal_svg__st1",
    d: "M59.6 12.9v14.8c0 1.4 1.1 2.5 2.5 2.5h1c1.3 0 2.3-.9 2.5-2.2v-.3c.6-4.4 4.3-7.7 8.8-7.7 4.5 0 8.2 3.3 8.8 7.7v.3c.2 1.3 1.2 2.2 2.5 2.2 1.4 0 2.5-1.1 2.5-2.5V12.9c0-1.1-.9-2-2-2H61.6c-1.1.1-2 1-2 2zM61 72.3l-7.8 8.3-3.8-3.8M49.4 59.8l9.3-9.4M58.7 59.8l-9.3-9.4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "journal_svg__st1",
    d: "M49.4 104.5l9.3-9.3M58.7 104.5l-9.3-9.3"
  }))));
}
export default SvgJournal;